import React, { Fragment } from 'react'
import CustomToolTip from '../../../../../../CommonComponents/CustomToolTip'
import { ADCSSvg, DataFlowSvg, OnboardScheduleSvg, PinnedSvg, PowerSvg } from './svgs/Svgs'
import { CircularProgress } from '@mui/material';

interface ModalDetails {
    open: boolean;
    pinned: boolean;
    current_modal: boolean | string;
    expanded: boolean | string;
}
interface Props {
    open_modal: (modal: string) => void;
    close_modal: (modal: string) => void;
    modals_details: {
        'power': ModalDetails;
        'data_flow': ModalDetails;
        'adcs': ModalDetails;
        'schedule': ModalDetails;
    };
    show_schedule_notification: boolean;
    prediction_data: boolean;
    scenario_scheduled: boolean;
    prediction_loading: boolean | string;
}

const RightHeaderSection: React.FC<Props> = ({ open_modal, close_modal, prediction_loading, modals_details, show_schedule_notification, prediction_data, scenario_scheduled }) => {

    const toggle_modal = (modal: string) => {
        if (modals_details[modal].open) {
            close_modal(modal)
        } else {
            open_modal(modal)
        }
    }

    return (
        <Fragment>
            <div className={`right__button__container`} onClick={(e: any) => { e.stopPropagation() }}>
                <CustomToolTip title='Schedule' placement='bottom'>
                    <button className={`right__section__button single__btn ${(modals_details['schedule'].open || show_schedule_notification) && 'active'} ${!scenario_scheduled && 'disabled'}`}
                        onClick={() => { toggle_modal('schedule') }}>
                        <OnboardScheduleSvg />
                        <PinnedSvg showPinned={modals_details['schedule'].pinned} />
                    </button>
                </CustomToolTip>
            </div>
            {!prediction_loading &&
                <div className='right__button__container' onClick={(e: any) => { e.stopPropagation() }}>
                    <CustomToolTip title='Power' placement='bottom'>
                        <button className={`right__section__button left__btn ${modals_details['power'].open && 'active'} ${!prediction_data && 'disabled'}`}
                            onClick={() => { toggle_modal('power') }}>
                            <PowerSvg />
                            <PinnedSvg showPinned={modals_details['power'].pinned} />
                        </button>
                    </CustomToolTip>
                    <CustomToolTip title='ADCS' placement='bottom'>
                        <button className={`right__section__button center__btn ${modals_details['adcs'].open && 'active'} ${!prediction_data && 'disabled'}`}
                            onClick={() => { toggle_modal('adcs') }}>
                            <ADCSSvg />
                            <PinnedSvg showPinned={modals_details['adcs'].pinned} />
                        </button>
                    </CustomToolTip>
                    <CustomToolTip title='Data Flow' placement='bottom'>
                        <button className={`right__section__button right__btn ${modals_details['data_flow'].open && 'active'} ${!prediction_data && 'disabled'}`}
                            onClick={() => { toggle_modal('data_flow') }}>
                            <DataFlowSvg />
                            <PinnedSvg showPinned={modals_details['data_flow'].pinned} />
                        </button>
                    </CustomToolTip>
                </div>
            }
            {prediction_loading &&
                <Fragment>
                    <div className='deploy__notification__container'>
                        <i className='fe fe-info' />
                        <span>Deploy to skip</span>
                    </div>
                    <div className='right__button__loading__container' onClick={(e: any) => { e.stopPropagation() }}>
                        {prediction_loading}
                        <CircularProgress size={10} className="color-atmos" />
                    </div>
                </Fragment>
            }
        </Fragment>
    )
}

export default RightHeaderSection